import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("意见反馈")
const _hoisted_2 = { class: "text-grey" }
const _hoisted_3 = { class: "text-grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormOutlined = _resolveComponent("FormOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showDialog && _ctx.showDialog(...args)), ["prevent"]))
    }, [
      (!_ctx.hideIcon)
        ? (_openBlock(), _createBlock(_component_FormOutlined, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.hideIcon?'':'ml10')
      }, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _hoisted_1
        ])
      ], 2)
    ]),
    _createVNode(_component_a_modal, {
      title: "反馈意见和建议",
      visible: _ctx.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event)),
      "confirm-loading": _ctx.confirmLoading,
      onOk: _ctx.handleOk
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "vertical",
          ref: "formRef",
          model: _ctx.formState,
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "您的称呼：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "称呼，40字符以内，选填",
                  maxlength: 50,
                  value: _ctx.formState.name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.name) = $event))
                }, {
                  suffix: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.formState.name.length) + "/50 ", 1)
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "联系电话：" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "建议留手机号，方便联系您",
                  maxlength: 20,
                  value: _ctx.formState.mobile,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.mobile) = $event))
                }, {
                  suffix: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formState.mobile.length) + "/20 ", 1)
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "反馈意见：",
              name: "content"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: _ctx.formState.content,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.content) = $event)),
                  maxlength: 1000,
                  placeholder: "请输入您的反馈意见或建议，1000字以内，必填",
                  "auto-size": { minRows: 3 }
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading", "onOk"])
  ], 64))
}